module.exports = __webpack_public_path__ + "img/EP18Menu1_active.522452f2.png";